export default __webpack_public_path__ + "static/media/90.6df40c23.jpg";